// Generated by CoffeeScript 2.7.0
var FIELDS, SettingsTencentWecity;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

FIELDS = [
  {
    id: -1,
    title: 'App ID',
    key: 'appId',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: 'Secret Id',
    key: 'secretId',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -3,
    title: 'Secret Key',
    key: 'secretKey',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -4,
    title: 'Expires',
    key: 'expires',
    type: 'Field::Integer',
    settings: {
      layout: null
    },
    _editing: true
  }
];

export default SettingsTencentWecity = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'field-list': FieldList
  },
  props: {
    activeTab: {
      type: String
    },
    tencentWecity: {
      type: Object
    }
  },
  data: function() {
    return {
      appId: this.tencentWecity.appid,
      secretId: this.tencentWecity.secret_id,
      secretKey: this.tencentWecity.secret_key,
      expires: this.tencentWecity.expires,
      updateDisabled: false
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <field-list :fields="fields"
                :response="response"
                :entries="response.entries"
                :editing="true"
                extendClass="form-field-group field-list-two-item"
                ref="fieldsListRef" />
    <div class="content-footer">
      <button class="content-footer-btn" :disabled="updateDisabled" @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  computed: {
    fields: function() {
      return _.map(FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    response: function() {
      return new Skylark.App.Model.Response({
        id: '_settings_first_attributes_response',
        entries: [
          {
            field_id: -1,
            value: this.appId
          },
          {
            field_id: -2,
            value: this.secretId
          },
          {
            field_id: -3,
            value: this.secretKey
          },
          {
            field_id: -4,
            value: this.expires
          }
        ]
      });
    }
  },
  methods: {
    updateSettings: function() {
      var data, entries;
      this.updateDisabled = true;
      entries = this.$refs.fieldsListRef.getEntries();
      this._transferEntries(entries);
      data = {
        namespace: {
          tencent_wecity: {
            appid: this.appId,
            secret_id: this.secretId,
            secret_key: this.secretKey,
            expires: this.expires
          }
        }
      };
      return Skylark.Libs.Ajax.patch('/admin/settings/tencent_wecity.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, err) {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'danger'
          });
        },
        complete: () => {
          return this.updateDisabled = false;
        }
      });
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    },
    _transferEntries: function(entries) {
      return _.each(FIELDS, (field) => {
        var entry;
        entry = _.find(entries, function(entry) {
          return field.id === entry.field_id;
        });
        if (entry) {
          return this[field.key] = entry.value;
        } else {
          return this[field.key] = '';
        }
      });
    }
  }
});
